<template>
  <div class="terms-conditions">
    <cms-content type="1" :lang="lang"/>
  </div>
</template>

<script>
  import CmsContent from '@/components/CmsContent.vue'
  export default {
    components: {
      CmsContent
    },
    computed:{
      lang(){
        return localStorage.lang
      }
    }
  }
</script>
